module.exports = __webpack_public_path__ + "static/media/super-icon.b640df17.png";